
import { ChevronRight, Home } from "lucide-react";
import { Link, useLocation } from "react-router-dom";

export const AdminBackBreadcrumb = () => {
  const location = useLocation();
  const path = location.pathname;
  
  // Don't show breadcrumb on admin home page
  if (path === "/admin") {
    return null;
  }
  
  // Extract page name from path
  const pathSegments = path.split('/').filter(Boolean);
  const currentPage = pathSegments[pathSegments.length - 1];
  const formattedPageName = currentPage
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
  
  // Handle special case for contact/[id]
  const isContactDetail = pathSegments.length > 2 && pathSegments[1] === "contact";
  const pageTitle = isContactDetail ? "Client Details" : formattedPageName;

  return (
    <div className="flex items-center space-x-2 mb-6">
      <Link 
        to="/admin" 
        className="text-primary hover:text-primary/90 text-sm flex items-center"
      >
        <Home className="h-4 w-4 mr-1" />
        Admin Dashboard
      </Link>
      <ChevronRight className="h-4 w-4 text-muted-foreground" />
      <span className="text-sm font-medium">{pageTitle}</span>
    </div>
  );
};
